// components/FrappeFormEmbed.tsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./EnquiryModal.module.scss";
import LazyMedia from "../LazyMedia";
import Shimmer from "../Shimmer";
import ShimmerItem from "../Shimmer/ShimmerItem";
import { useRouter } from "next/router";
import InlineFormShimmer from "./InlineFormShimmer";

type FrappeFormEmbedProps = {
  iframeUrl: string; // URL where Frappe form is hosted
  frappeWrapperClass?: string;
  mode?: "popup" | "inline";
  loader?: "shimmer" | "spinner";
};

const FrappeFormEmbed: React.FC<FrappeFormEmbedProps> = ({
  iframeUrl,
  frappeWrapperClass,
  mode = "popup",
  loader = "spinner",
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [encodedUrl, setEncodedUrl] = useState("");

  useEffect(() => {
    // This runs only on the client side
    const currentUrl = window.location.href;
    const encoded = encodeURIComponent(currentUrl);
    setEncodedUrl(encoded);
  }, []);

  const handleOnIframeLoad = () => {
    setTimeout(() => setIsLoading(false), 100);
  };

  return (
    <>
      {isLoading && (
        <div className={styles.loaderBackground}>
          {loader === "spinner" && <div className={styles.spinner} />}
          {loader === "shimmer" && (
            <InlineFormShimmer />
          )}
        </div>
      )}
      {mode === "popup" ? (
        <iframe
          title="Form submission"
          src={`${iframeUrl}/new?source_url=${encodedUrl}`}
          width="100%"
          className={`${styles.iframe} ${frappeWrapperClass}`}
          onLoad={handleOnIframeLoad}
        />
      ) : (
        <LazyMedia
          loader="shimmer"
          src={`${iframeUrl}/new?source_url=${encodedUrl}`}
          width="100%"
          iframeClassName={`${styles.iframe} ${frappeWrapperClass}`}
          onLoad={handleOnIframeLoad}
        />
      )}
    </>
  );
};

export default FrappeFormEmbed;
